// extracted by mini-css-extract-plugin
module.exports = {"readmore":"TheHomeChairmantalk_readmore_2PK4b","spinAround":"TheHomeChairmantalk_spinAround_1qZHv"};